export default __webpack_public_path__ + "static/media/Hindi.b457ae1b.mp3";